import { useState, useEffect, useRef } from 'react'
import adviseLogo from '../assets/img/advise_consultore_logo-removebg-preview.png'
import NormalNavbar from '../elements/NormalNavbar';
import BurgerNavbar from '../elements/BurgerNavbar';


export default function Navbar(props){

    const [selected, setSelected] = useState(0);
    const [isInHero, setIsInHero] = useState(true);
    const [isBurgerOpen, setIsBurgerOpen] = useState(false);

    const navbarRef = useRef(null);

    const options = ["INICIO", "QUIENES SOMOS", "NUESTROS SERVICIOS", "NUESTROS PRODUCTOS", "CLIENTES", "CONTACTENOS", "AYUDA"];
    const routes = ["start", "us", "services", "products", "clients", "contact-us", "help"];

    const navbarStartClass = ''
    const navbarEndClass= 'bg-advise-color'

    const scrollToSection = (event, sectionId) => {
        event.preventDefault();
        const targetElement = document.getElementById(sectionId);
    
        if(targetElement !== null && targetElement !== undefined){
            const offset = 50;
            const elementPosition = targetElement.getBoundingClientRect().top;
            const offsetPosition = Math.max(elementPosition + window.pageYOffset - offset, 0);

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }   
    };

    function handleBaseNavbar(){
        const targetDiv = document.querySelector('.navbar-target');
        if(!targetDiv.getBoundingClientRect()) return
        
        const targetDivTop = targetDiv.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (targetDivTop < windowHeight && targetDivTop > 0) {
            const percentage = 1 - targetDivTop / windowHeight;
            if (percentage > 0.5) {
                setIsInHero(false);
            } else {
                setIsInHero(true);
            }
        } else if (targetDivTop <= 0) {
            setIsInHero(false);
        } else {
            setIsInHero(true);
        }
    }

    function handleItemNavbar(routeIndex) {
        const targetDiv = document.getElementById(routes[routeIndex]);
        if(!targetDiv) return

        const targetDivTop = targetDiv.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (targetDivTop < windowHeight && targetDivTop > 0) {
            const percentage = 1 - targetDivTop / windowHeight;
            if (percentage > 0.5) {
                setSelected(parseInt(routeIndex));
            }
            else{
                setSelected(parseInt(routeIndex) - 1)
            }
        }
    }

    useEffect(() => {
        const handleScroll = () => {
            handleBaseNavbar()
            for(const rIndex in routes){
                handleItemNavbar(rIndex)
            }
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
    /* eslint-disable-next-line */
    }, []);

    function manageNavbarClick(event, optionValue){
        setSelected(optionValue);
        scrollToSection(event, routes[optionValue])
    }

    return(
        <nav ref={navbarRef} 
            className={`${isInHero && (!isBurgerOpen || props.isLargeScreen) ? navbarStartClass : navbarEndClass} fixed w-full z-20 top-0 start-0`} 
            style={{transition: "background-color 0.5s"}}>
            <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
                <a href='/' className="flex items-center space-x-3 rtl:space-x-reverse">
                    <img src={adviseLogo} className="h-12" alt="Flowbite Logo" />
                </a>
                {props.isLargeScreen ? 
                    <NormalNavbar options={options}
                                  routes={routes}
                                  selected={selected}
                                  manageClick={manageNavbarClick}
                                  isInHero={isInHero}
                    />
                    :
                    <BurgerNavbar options={options}
                                  routes={routes}
                                  selected={selected}
                                  manageClick={manageNavbarClick}
                                  navbarRef={navbarRef}
                                  isOpen={isBurgerOpen}
                                  setIsOpen={setIsBurgerOpen}/>
                }
                
            </div>
        </nav>
    )
}